import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  Divider,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface InsightLink {
  industry?: string;
  businessSize?: string;
  type: string;
  title: string;
  link: string;
}

// New component for rendering insights
const InsightsSection: React.FC<{
  title: string;
  links: InsightLink[];
  onVideoClick: (src: string) => void;
  onLinkClick?: (link: string) => void;
}> = ({ title, links, onVideoClick, onLinkClick }) => (
  <Box sx={{ p: 3, pr: 4, borderBottom: 1, borderColor: 'divider' }}>
    <Typography variant="subtitle1" sx={{ mb: 1, color: 'var(--mui-custom-grey)' }}>
      {title}
    </Typography>
    <Divider sx={{ borderColor: '#ffffff82', mb: 2 }} />
    <List dense>
      {links
        .filter((link) => link.link !== '-')
        .map((link, index) => (
          <ListItem key={index} disablePadding sx={{ mb: 1 }}>
            {link.type === 'Video' ? (
              <Box
                onClick={() => onVideoClick(link.link)}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'flex-start',
                  width: '100%',
                }}
              >
                <VideoLibraryIcon sx={{ color: 'white', mr: 1, mt: 0.5, flexShrink: 0 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: 'white',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    hyphens: 'auto',
                  }}
                >
                  {link.title}
                </Typography>
              </Box>
            ) : (
              <Box
                component="a"
                href={link.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onLinkClick?.(link.link)}
                sx={{
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'flex-start',
                  width: '100%',
                }}
              >
                {link.type === 'PDF' ? (
                  <PictureAsPdfIcon sx={{ color: 'white', mr: 1, mt: 0.5, flexShrink: 0 }} />
                ) : (
                  <OpenInNewIcon sx={{ color: 'white', mr: 1, mt: 0.5, flexShrink: 0 }} />
                )}
                <Typography
                  variant="body2"
                  sx={{
                    color: 'white',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    hyphens: 'auto',
                  }}
                >
                  {link.title}
                </Typography>
              </Box>
            )}
          </ListItem>
        ))}
    </List>
  </Box>
);

export default InsightsSection;